import { all, put,call, takeLatest } from 'redux-saga/effects';
import * as Legislacao from '~/services/LegislacaoAtividade';
import  * as actionType from './actionType';
import * as actions from './action';
import { getErros } from '~/store/modules/errors/action';

function* loadLegislacoesWorker({params}) {
  try {
    const response = yield call(Legislacao.load, params);
    yield put(actions.getLegislacoes(response));
    yield put(actions.getErros({}));
    yield put(getErros({}));
  } catch (error) {
    if (error.response) {
      yield put(actions.getErros(error.response));
      yield put(getErros(error.response));
    } else if (error.request) {
      yield put(getErros({data: error.message}));
    } else {
      yield put(getErros({data: error.message}));
    }
  }
}

function* loadSelectLegislacoesWorker() {
  try {
    const response = yield call(Legislacao.select);
    yield put(actions.getSelectLegislacoes(response));
    yield put(actions.getErros({}));
    yield put(getErros({}));
  } catch (error) {
    if (error.response) {
      yield put(actions.getErros(error.response));
      yield put(getErros(error.response));
    } else if (error.request) {
      yield put(getErros({ data: error.message }));
    } else {
      yield put(getErros({ data: error.message }));
    }
  }
}

function* showLegislacaoWorker({id}) {
  try {
    const response = yield call(Legislacao.show, id);
    yield put(actions.getLegislacao(response));
    yield put(actions.getErros({}));
    yield put(getErros({}));

  } catch (error) {
    if (error.response) {
      yield put(actions.getErros(error.response));
      yield put(getErros(error.response));
    } else if (error.request) {
      yield put(getErros({data: error.message}));
    } else {
      yield put(getErros({data: error.message}));
    }
  }
}

function* updateLegislacaoWorker({ legislacao, id}) {
  try {
    const response = yield call(Legislacao.update, id, legislacao);
    yield put(actions.getLegislacao(response));
    yield put(actions.getErros({update:true}));
    yield put(getErros({update:true}));

  } catch (error) {
    if (error.response) {
      yield put(actions.getErros(error.response));
      yield put(getErros(error.response));
    } else if (error.request) {
      yield put(getErros({data: error.message}));
    } else {
      yield put(getErros({data: error.message}));
    }
  }
}

function* storeLegislacaoWorker({legislacao}) {
  try {
    const response = yield call(Legislacao.store, legislacao);
    yield put(actions.getLegislacao(response));
    yield put(actions.getErros({save:true}));
    yield put(getErros({save:true}));

  } catch (error) {
    if (error.response) {
      yield put(actions.getErros(error.response));
      yield put(getErros(error.response));
    } else if (error.request) {
      yield put(getErros({data: error.message}));
    } else {
      yield put(getErros({data: error.message}));
    }
  }
}

function* removerLegislacaoWorker({id}) {
  try {
    yield call(Legislacao.destroy, id);
    yield put(actions.getErros({}));
    yield put(getErros({}));

  } catch (error) {
    if (error.response) {
      yield put(actions.getErros(error.response));
      yield put(getErros(error.response));
    } else if (error.request) {
      yield put(getErros({data: error.message}));
    } else {
      yield put(getErros({data: error.message}));
    }
  }
}

function* ativarLegislacaoWorker({id}) {
  try {
    yield call(Legislacao.activate, id);
    yield put(actions.getErros({}));
    yield put(getErros({}));

  } catch (error) {
    if (error.response) {
      yield put(actions.getErros(error.response));
      yield put(getErros(error.response));
    } else if (error.request) {
      yield put(getErros({data: error.message}));
    } else {
      yield put(getErros({data: error.message}));
    }
  }
}

function* watcherLegislacao() {
  yield takeLatest(actionType.LOAD_LEGISLACOES, loadLegislacoesWorker);
  yield takeLatest(actionType.LOAD_SELECT_LEGISLACOES, loadSelectLegislacoesWorker);
  yield takeLatest(actionType.STORE_LEGISLACAO, storeLegislacaoWorker);
  yield takeLatest(actionType.SHOW_LEGISLACAO, showLegislacaoWorker);
  yield takeLatest(actionType.UPDATE_LEGISLACAO, updateLegislacaoWorker);
  yield takeLatest(actionType.REMOVER_LEGISLACAO, removerLegislacaoWorker);
  yield takeLatest(actionType.ACTIVE_LEGISLACAO, ativarLegislacaoWorker);
}

export default function* saga() {
  yield all([watcherLegislacao()]);
}
